import * as React from 'react';
import type { SVGIconProps } from './Icon.types';

const PartlyRecognisedIcon = React.forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        ref={forwardedRef}
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <title>{props.title}</title>
        <circle cx="12" cy="12" fill="none" r="10" stroke={color} strokeWidth="2.6" />
        <path d="M12 2 a10 10 0 0 0 0 20 z" fill={color} />
      </svg>
    );
  },
);

export default PartlyRecognisedIcon;
